/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createArtist = /* GraphQL */ `
  mutation CreateArtist(
    $input: CreateArtistInput!
    $condition: ModelArtistConditionInput
  ) {
    createArtist(input: $input, condition: $condition) {
      cognitoId
      artistName
      hometown
      biography
      preferredGenres {
        items {
          id
          artist {
            cognitoId
            artistName
            hometown
            biography
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      follows {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          artistId
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateArtist = /* GraphQL */ `
  mutation UpdateArtist(
    $input: UpdateArtistInput!
    $condition: ModelArtistConditionInput
  ) {
    updateArtist(input: $input, condition: $condition) {
      cognitoId
      artistName
      hometown
      biography
      preferredGenres {
        items {
          id
          artist {
            cognitoId
            artistName
            hometown
            biography
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      follows {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          artistId
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteArtist = /* GraphQL */ `
  mutation DeleteArtist(
    $input: DeleteArtistInput!
    $condition: ModelArtistConditionInput
  ) {
    deleteArtist(input: $input, condition: $condition) {
      cognitoId
      artistName
      hometown
      biography
      preferredGenres {
        items {
          id
          artist {
            cognitoId
            artistName
            hometown
            biography
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      follows {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          artistId
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFan = /* GraphQL */ `
  mutation CreateFan(
    $input: CreateFanInput!
    $condition: ModelFanConditionInput
  ) {
    createFan(input: $input, condition: $condition) {
      cognitoId
      fullName
      favoriteGenres {
        items {
          id
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      zipCode
      allFeedback {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          sessionId
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      allLikes {
        items {
          id
          likeValue
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          sessionId
          createdAt
          updatedAt
        }
        nextToken
      }
      isReturningFan
      createdAt
      updatedAt
    }
  }
`;
export const updateFan = /* GraphQL */ `
  mutation UpdateFan(
    $input: UpdateFanInput!
    $condition: ModelFanConditionInput
  ) {
    updateFan(input: $input, condition: $condition) {
      cognitoId
      fullName
      favoriteGenres {
        items {
          id
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      zipCode
      allFeedback {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          sessionId
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      allLikes {
        items {
          id
          likeValue
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          sessionId
          createdAt
          updatedAt
        }
        nextToken
      }
      isReturningFan
      createdAt
      updatedAt
    }
  }
`;
export const deleteFan = /* GraphQL */ `
  mutation DeleteFan(
    $input: DeleteFanInput!
    $condition: ModelFanConditionInput
  ) {
    deleteFan(input: $input, condition: $condition) {
      cognitoId
      fullName
      favoriteGenres {
        items {
          id
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      zipCode
      allFeedback {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          sessionId
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      allLikes {
        items {
          id
          likeValue
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          sessionId
          createdAt
          updatedAt
        }
        nextToken
      }
      isReturningFan
      createdAt
      updatedAt
    }
  }
`;
export const createSession = /* GraphQL */ `
  mutation CreateSession(
    $input: CreateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    createSession(input: $input, condition: $condition) {
      id
      artistId
      spotifyUri
      spotifyId
      trackName
      artistName
      playCount
      genres {
        id
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        genre {
          id
          genre
          superGenre
          isSuperGenre
          fans {
            nextToken
          }
          artists {
            nextToken
          }
          sessions {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      isActive
      isArchived
      archivedDate
      isDeleted
      deletedDate
      createdAt
      updatedAt
      allFeedback {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          sessionId
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      allLikes {
        items {
          id
          likeValue
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          sessionId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const updateSession = /* GraphQL */ `
  mutation UpdateSession(
    $input: UpdateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    updateSession(input: $input, condition: $condition) {
      id
      artistId
      spotifyUri
      spotifyId
      trackName
      artistName
      playCount
      genres {
        id
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        genre {
          id
          genre
          superGenre
          isSuperGenre
          fans {
            nextToken
          }
          artists {
            nextToken
          }
          sessions {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      isActive
      isArchived
      archivedDate
      isDeleted
      deletedDate
      createdAt
      updatedAt
      allFeedback {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          sessionId
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      allLikes {
        items {
          id
          likeValue
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          sessionId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const deleteSession = /* GraphQL */ `
  mutation DeleteSession(
    $input: DeleteSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    deleteSession(input: $input, condition: $condition) {
      id
      artistId
      spotifyUri
      spotifyId
      trackName
      artistName
      playCount
      genres {
        id
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        genre {
          id
          genre
          superGenre
          isSuperGenre
          fans {
            nextToken
          }
          artists {
            nextToken
          }
          sessions {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      isActive
      isArchived
      archivedDate
      isDeleted
      deletedDate
      createdAt
      updatedAt
      allFeedback {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          sessionId
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      allLikes {
        items {
          id
          likeValue
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          sessionId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const createFeedback = /* GraphQL */ `
  mutation CreateFeedback(
    $input: CreateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    createFeedback(input: $input, condition: $condition) {
      id
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      sessionId
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      comment
      createdAt
      updatedAt
    }
  }
`;
export const updateFeedback = /* GraphQL */ `
  mutation UpdateFeedback(
    $input: UpdateFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    updateFeedback(input: $input, condition: $condition) {
      id
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      sessionId
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      comment
      createdAt
      updatedAt
    }
  }
`;
export const deleteFeedback = /* GraphQL */ `
  mutation DeleteFeedback(
    $input: DeleteFeedbackInput!
    $condition: ModelFeedbackConditionInput
  ) {
    deleteFeedback(input: $input, condition: $condition) {
      id
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      sessionId
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      comment
      createdAt
      updatedAt
    }
  }
`;
export const createTbLike = /* GraphQL */ `
  mutation CreateTbLike(
    $input: CreateTbLikeInput!
    $condition: ModelTbLikeConditionInput
  ) {
    createTbLike(input: $input, condition: $condition) {
      id
      likeValue
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      sessionId
      createdAt
      updatedAt
    }
  }
`;
export const updateTbLike = /* GraphQL */ `
  mutation UpdateTbLike(
    $input: UpdateTbLikeInput!
    $condition: ModelTbLikeConditionInput
  ) {
    updateTbLike(input: $input, condition: $condition) {
      id
      likeValue
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      sessionId
      createdAt
      updatedAt
    }
  }
`;
export const deleteTbLike = /* GraphQL */ `
  mutation DeleteTbLike(
    $input: DeleteTbLikeInput!
    $condition: ModelTbLikeConditionInput
  ) {
    deleteTbLike(input: $input, condition: $condition) {
      id
      likeValue
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      sessionId
      createdAt
      updatedAt
    }
  }
`;
export const createTbFollows = /* GraphQL */ `
  mutation CreateTbFollows(
    $input: CreateTbFollowsInput!
    $condition: ModelTbFollowsConditionInput
  ) {
    createTbFollows(input: $input, condition: $condition) {
      id
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      artistId
      createdAt
      updatedAt
    }
  }
`;
export const updateTbFollows = /* GraphQL */ `
  mutation UpdateTbFollows(
    $input: UpdateTbFollowsInput!
    $condition: ModelTbFollowsConditionInput
  ) {
    updateTbFollows(input: $input, condition: $condition) {
      id
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      artistId
      createdAt
      updatedAt
    }
  }
`;
export const deleteTbFollows = /* GraphQL */ `
  mutation DeleteTbFollows(
    $input: DeleteTbFollowsInput!
    $condition: ModelTbFollowsConditionInput
  ) {
    deleteTbFollows(input: $input, condition: $condition) {
      id
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      artistId
      createdAt
      updatedAt
    }
  }
`;
export const createGenre = /* GraphQL */ `
  mutation CreateGenre(
    $input: CreateGenreInput!
    $condition: ModelGenreConditionInput
  ) {
    createGenre(input: $input, condition: $condition) {
      id
      genre
      superGenre
      isSuperGenre
      fans {
        items {
          id
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      artists {
        items {
          id
          artist {
            cognitoId
            artistName
            hometown
            biography
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateGenre = /* GraphQL */ `
  mutation UpdateGenre(
    $input: UpdateGenreInput!
    $condition: ModelGenreConditionInput
  ) {
    updateGenre(input: $input, condition: $condition) {
      id
      genre
      superGenre
      isSuperGenre
      fans {
        items {
          id
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      artists {
        items {
          id
          artist {
            cognitoId
            artistName
            hometown
            biography
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteGenre = /* GraphQL */ `
  mutation DeleteGenre(
    $input: DeleteGenreInput!
    $condition: ModelGenreConditionInput
  ) {
    deleteGenre(input: $input, condition: $condition) {
      id
      genre
      superGenre
      isSuperGenre
      fans {
        items {
          id
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      artists {
        items {
          id
          artist {
            cognitoId
            artistName
            hometown
            biography
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createFanGenre = /* GraphQL */ `
  mutation CreateFanGenre(
    $input: CreateFanGenreInput!
    $condition: ModelFanGenreConditionInput
  ) {
    createFanGenre(input: $input, condition: $condition) {
      id
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateFanGenre = /* GraphQL */ `
  mutation UpdateFanGenre(
    $input: UpdateFanGenreInput!
    $condition: ModelFanGenreConditionInput
  ) {
    updateFanGenre(input: $input, condition: $condition) {
      id
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteFanGenre = /* GraphQL */ `
  mutation DeleteFanGenre(
    $input: DeleteFanGenreInput!
    $condition: ModelFanGenreConditionInput
  ) {
    deleteFanGenre(input: $input, condition: $condition) {
      id
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createArtistGenre = /* GraphQL */ `
  mutation CreateArtistGenre(
    $input: CreateArtistGenreInput!
    $condition: ModelArtistGenreConditionInput
  ) {
    createArtistGenre(input: $input, condition: $condition) {
      id
      artist {
        cognitoId
        artistName
        hometown
        biography
        preferredGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        follows {
          items {
            id
            fanId
            artistId
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateArtistGenre = /* GraphQL */ `
  mutation UpdateArtistGenre(
    $input: UpdateArtistGenreInput!
    $condition: ModelArtistGenreConditionInput
  ) {
    updateArtistGenre(input: $input, condition: $condition) {
      id
      artist {
        cognitoId
        artistName
        hometown
        biography
        preferredGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        follows {
          items {
            id
            fanId
            artistId
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteArtistGenre = /* GraphQL */ `
  mutation DeleteArtistGenre(
    $input: DeleteArtistGenreInput!
    $condition: ModelArtistGenreConditionInput
  ) {
    deleteArtistGenre(input: $input, condition: $condition) {
      id
      artist {
        cognitoId
        artistName
        hometown
        biography
        preferredGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        follows {
          items {
            id
            fanId
            artistId
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createSessionGenre = /* GraphQL */ `
  mutation CreateSessionGenre(
    $input: CreateSessionGenreInput!
    $condition: ModelSessionGenreConditionInput
  ) {
    createSessionGenre(input: $input, condition: $condition) {
      id
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateSessionGenre = /* GraphQL */ `
  mutation UpdateSessionGenre(
    $input: UpdateSessionGenreInput!
    $condition: ModelSessionGenreConditionInput
  ) {
    updateSessionGenre(input: $input, condition: $condition) {
      id
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteSessionGenre = /* GraphQL */ `
  mutation DeleteSessionGenre(
    $input: DeleteSessionGenreInput!
    $condition: ModelSessionGenreConditionInput
  ) {
    deleteSessionGenre(input: $input, condition: $condition) {
      id
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
